<template>
  <div>
    <b-modal :id="id" hide-footer scrollable :size="size" :no-close-on-backdrop="noCloseOnBackdrop" title-class="w-100" @show="shown" @hide="hidden">
      <template #modal-title>
        <h4 class="modal-title">{{ title }}</h4>
      </template>
      <template #modal-header-close>
        <i class="iconoir-xmark"></i>
      </template>

      <slot></slot>
    </b-modal>
  </div>
</template>

<script>
export default {
  // TKP-236 n.12: boyut ve "dışına tıklayınca kapanmasın" (uzun formda girilenler kaybolmasın) seçilebilir; varsayılanlar eskisi gibi
  props: { id: String, title: String, size: { type: String, default: "lg" }, noCloseOnBackdrop: { type: Boolean, default: false } },

  data() {
    return {
      variant: "dark",
    };
  },
  methods: {
    hidden() {
      this.$emit("hidden");
    },
    shown() {
      this.$emit("shown");
    },
    click() {
      this.$emit("click");
    },
  },
};
</script>
<style scoped>
.iconoir-xmark {
  font-size: 2.5rem;
  color: #ff7c48;
  cursor: pointer;
}

.iconoir-xmark:hover {
  color: #ff6d34;
}
::v-deep .modal-header {
  border-bottom: none !important;
}
.modal-title {
  color: #071437;
  font-size: 1rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-top: 0.66rem;
}

.title {
  padding: 0.3rem 0.6rem;
  border-radius: 0.1875rem;
  background: #f5f7f9;
  color: #99a1b7;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  cursor: pointer;
  border-radius: 0.1875rem;
  background: #f2e0da;
  color: #ff7c48;
}
</style>
